export default {
	terms: "Általános Szerződési Feltételek",
	and: "És",
	actions: {
		Submit: "Beküldés",
		BackToLogin: "Vissza a bejelentkezéshez",
		Register: "Regisztráció",
		Logout: "Kijelentkezés",
		Update: "Frissítés",
		Verify: "Ellenőrizni",
		connect: "Csatlakozás",
		Taptochange: "Érintse meg a változtatáshoz"
	},
	rules: {
		isRequired: "Szükséges",
		require: "{0} szükséges",
		valid: "{0} nem érvényes {0}",
		cannotContainBlankStrings: "{0} nem tartalmazhat üres karakterláncokat"
	},
	options: {
		gender: ["Férfi", "Nő"]
	}
};
